import React, { createContext, useContext, useState } from "react";

const CarContext = createContext(undefined);
export const CarProvider = ({
  children,
}) => {
    const [cars, setCars] = useState(null);
    const [carModels, setCarModels] = useState(null);
    const [carDetails, setCarDetails] = useState(null);
    return (
        <CarContext.Provider
        value={{
            cars,
            setCars,
            carModels,
            setCarModels,
            carDetails,
            setCarDetails
        }}
        >
            {children}
        </CarContext.Provider>
    );
};
export const useCarContext = () => {
  const context = useContext(CarContext);
  if (!context) {
    throw new Error("useCarContext must be used within a CarProvider");
  }
  return context;
};